//
//
//
//
//
//
//
//
//
//
//
//

const MAX_TIME = 10 * 1000
export default {
    props: {
        building: {
            type: Object
        }
    },
    data () {
        return {
            show: true
        }
    },
    mounted () {
        setTimeout(() => {
            this.show = false
        }, MAX_TIME)
    },
    methods: {
        send () {
            this.$emit('send')
            this.show = false
        }
    }
}
